/**  
 * 定义组件内部或多个组件间共享数据或使用的变量  
**/  
import { shallowRef, reactive } from 'vue';
export const userPermissions = shallowRef([]);    // 用户权限，使用shallowRef优化性能
export const cardData = shallowRef([]);           // 用户授权信息，使用shallowRef优化性能
export const customerData = shallowRef([]);       // 客户信息
export const productData = shallowRef([]);        // 产品信息
export const algorithmsData = shallowRef([]);     // 算法类型
export const versionTypeData = shallowRef([]);    // 版本类型
export const logData = shallowRef([]);            // 用户授权日志
export const summaryData = shallowRef([]);        // 授权日期汇总信息
export const statusData = shallowRef([]);     // 授权日期状态 

export const state = reactive({
    // 各个选择器的数据源
    pickerData: {
      customer: [],    // 客户数据
      product: [],     // 产品数据
      vertype: [],     // 版本类型
      algorithm: [],   // 算法类型
    },
   
    newLicense: {         // 当前选中的卡片信息
      product: {
        id: 0,
        name: '',
      },  
      customer: {
        id: 0,
        name: '',
      },   
      shortname: '',    // 设备号-现场机台编号
      vertype: {
        id: 0,
        name: '',
      },  
      slavedesc: '',    // 下位机信息
      version: '',      // 现场软件版本号
      algorithm: {
        id: 0,
        name: '',
      },    // 默认算法类型  
      imageurl: {
        type: String,
        required: true,
      }},   
      
      // 各种选择器的弹窗显示状态
      showPicker: {
        customer: false,
        product: false,
        vertype: false,
        algorithm: false,
      }
    });